// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductReport":"en_a bhj_a bhj_x bhj_j bhj_u bhj_bc bhj_pp bhj_up"};